export default __webpack_public_path__ + "static/Image084-8db28057fb991e4b75c49eff2f232ba7.png";